import { RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA } from '../constants/SLAProperties';
const resolvedStatuses = [RESOLVED_IN_SLA, RESOLVED_OUT_OF_SLA];
export const getIsSLAResolved = slaStatus => resolvedStatuses.includes(slaStatus);